export const calcSuitablePrice = (product, qty, company) => {
  let res = null;

  const allMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const month = new Date().getMonth() + 1;

  const prices = product.prices.filter(
    (i) => i.archivedAt === null && i.company === company,
  );

  let sortedPrices = prices
    .filter((i) => i.archivedAt === null && i.company === company)
    .filter((i) => {
      if (i.avaliableToMonth === 1 && i.avaliableToMonth === 12) return true;

      const start = i.avaliableFromMonth;
      const end = i.avaliableToMonth;
      const startBiggerThanEnd = start > end;

      const validMonths = startBiggerThanEnd
        ? allMonths.filter((m) => m <= end || m >= start)
        : allMonths.filter((m) => m >= start && m <= end);
      return validMonths.includes(month);
    })
    .sort((a, b) => a.minQty - b.minQty);

  const costSupplier = product.suppliers.find(
    (i) => i.company == company && i.useType === "COST",
  );

  if (costSupplier) {
    sortedPrices = sortedPrices.filter(
      (i) => i.factory && i.factory.id === costSupplier.supplier.id,
    );
  } else {
    // If no cost supplier, check if there are multiple suppliers. If so, return null. We don't know which one to use.
    const sortedPricesSupplierIds = sortedPrices
      .map((i) => i.factory.id)
      .reduce((acc, id) => {
        if (!acc.includes(id)) acc.push(id);
        return acc;
      }, []);
    if (sortedPricesSupplierIds.length > 1) return null;
  }

  if (sortedPrices.length > 0) {
    sortedPrices = sortedPrices
      .filter((i) => i.minQty <= qty)
      .sort((a, b) => a.price - b.price);
    res = sortedPrices[0];
  }
  return res;
};

export const productCost = (product, qty, rate, currency, company) => {
  const res = calcSuitablePrice(product, qty, company);
  if (res) {
    if (currency !== res.currency) {
      // for now, only USD and RMB are supported
      if (res.currency === "USD") {
        return res.price;
      }
      if (res.currency === "RMB" || res.currency === "CNY") {
        return res.price / rate;
      }
      throw new Error("Unsupported currency");
    }
    return res.price;
  }
  return 0;
};

export const childCost = (child, set, rate, currency, company) => {
  const qty = child.qty * set;
  const res = productCost(child.product, qty, rate, currency, company) * qty;
  if (isNaN(res)) return 0;
  return res;
};

export const productItemsPerSet = (product) => {
  let itemsPerSet = product.itemsPerSet;
  if (!itemsPerSet)
    itemsPerSet = Math.max.apply(
      Math,
      product.children.map((i) => i.qty),
    );
  return itemsPerSet;
};

// Compute the cost of a product per unit with BOM
export const productUnitCost = (
  product,
  qty,
  rate,
  currency = "USD",
  company,
) => {
  const itemsPerSet = productItemsPerSet(product);
  const sets = qty / itemsPerSet;
  if (sets < 1) return 0;
  const res =
    product.children.reduce((prev, child) => {
      return prev + childCost(child, sets, rate, currency, company);
    }, 0) / qty;
  if (isNaN(res)) return 0;
  return res;
};
